import React from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import Stores from 'Stores'
import st from './PayServiceSection.module.scss'

const PayServiceSection = ({ banks, onChange, value }) => {
  return (
    <div className={st.payService}>
      <div className={st.selectPayment}>
        {localisationMaster('select_payment_method', 'pays/invoice')}
      </div>
      <div className={st.servicesBox}>
        {banks.map((el) => (
          <div
            className={`${st.service} ${el.id === value ? st.serviceSelected : ''}`}
            key={el.id}
            onClick={() => onChange(el.id)}
          >
            <div
              className={`${st.initialsBank} ${el.id === value ? st.initialsBankSelected : ''}`}
            >
              {el.logo === null ? (
                el?.name
                  ?.split(' ')
                  .filter((word) => word)
                  .map((word) => word[0].toUpperCase())
                  .join('')
              ) : (
                <img
                  src={`${Stores.baseLink()}${el.logo}`}
                  alt={`${el.name}`}
                />
              )}
            </div>
            <div
              className={`${st.nameBank} ${el.id === value ? st.colorSelectedWhite : ''}`}
            >
              {el.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PayServiceSection
